import { render, staticRenderFns } from "./gender-selector.vue?vue&type=template&id=39cbad48&"
import script from "./gender-selector.vue?vue&type=script&lang=js&"
export * from "./gender-selector.vue?vue&type=script&lang=js&"
import style0 from "./gender-selector.vue?vue&type=style&index=0&lange=less&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports